import { styled } from 'styled-components';

export default styled.input`
  flex-grow: 1;
  margin: 0.25rem;
  border: none;
  outline: none;
  border-bottom: 1px solid #ccc;
  font-size: 1.5rem;
  font-family: 'Sanko';

  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  cursor: pointer;
  // width: 15rem;
  &::-webkit-slider-runnable-track {
    background: blue;
    height: 0.5rem;
  }
  &::-moz-range-track {
    border: none;
    background: blue;
    height: 0.5rem;
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    margin-top: -12px; /* Centers thumb on the track */
    background-color: #c0c0c0;
    border: 2pt solid gray;
    height: 2rem;
    width: 1rem;
    box-shadow: none;
  }

  &::-moz-range-thumb {
    border: none; /*Removes extra border that FF applies*/
    border-radius: 0; /*Removes default border-radius that FF applies*/
    background-color: #c0c0c0;
    border: 2pt solid gray;
    height: 2rem;
    width: 1rem;
    box-shadow: none;
  }
`;
